const AUTH_CODES = new Set([
  'NO_AUTH',
  'INVALID_TOKEN',
  'SESSION_VALIDATION_ERROR'
])

const AUTH_MESSAGE_HINTS = [
  'token',
  'api key',
  'sesión',
  'sesion',
  'expired',
  'authentication',
  'jwt'
]

function asRecord(data: unknown): Record<string, unknown> | null {
  if (!data || typeof data !== 'object') return null
  return data as Record<string, unknown>
}

function readText(value: unknown): string {
  if (typeof value !== 'string') return ''
  return value.trim()
}

/**
 * 401 de negocio: el pedido no tiene stock en Flexy y el API rechaza el cambio de estado.
 * No es una sesión vencida.
 */
export function isFlexyStockStatusRejection(data: unknown): boolean {
  const body = asRecord(data)
  if (!body) {
    const text = readText(data).toLowerCase()
    return text.includes('sin stock') || (text.includes('stock') && text.includes('flexy'))
  }

  const code = readText(body.code)
  const status = readText(body.status)
  const text = `${readText(body.message)} ${readText(body.error)}`.toLowerCase()

  if (code === 'FLEXY_STOCK_INSUFFICIENT' || status === 'sin_stock_flexy') return true
  if (text.includes('sin stock')) return true
  if (text.includes('stock insuficiente')) return true
  if (text.includes('stock') && text.includes('flexy')) return true
  return false
}

/** Cierra sesión solo si el cuerpo indica autenticación inválida. */
export function shouldLogoutForApiError(status: number | undefined, data: unknown): boolean {
  if (isFlexyStockStatusRejection(data)) return false

  const body = asRecord(data)
  const code = (body ? readText(body.code) || readText(body.error) : '').toUpperCase()
  const message = body
    ? `${readText(body.message)} ${readText(body.error)}`.trim().toLowerCase()
    : readText(data).toLowerCase()

  if (AUTH_CODES.has(code)) return true
  if (AUTH_MESSAGE_HINTS.some((hint) => message.includes(hint))) return true
  if (status === 401 && !code && !message) return true
  return false
}
